import { FutureCheckbox } from 'components/features/future/FutureCheckbox/FutureCheckbox'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { FC, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { ToggleComparisonAction } from 'components/features/pageFilters/actions'
import styles from 'components/features/pageFilters/ToggleComparison/ToggleComparison.styl'
import cn from 'classnames'

type ToggleComparisonProps = {
  className?: string
}
export const ToggleComparison: FC<ToggleComparisonProps> = (props) => {
  const { className } = props

  const dispatch = useStoreDispatch()

  const initialComparison = useStoreSelector((state) => {
    return state.app.pageFilters.comparison
  })

  const { register, watch } = useForm<{ comparison: boolean }>({
    defaultValues: {
      comparison: initialComparison,
    },
  })
  const comparison = watch('comparison')

  useEffect(() => {
    if (comparison === undefined) {
      return
    }

    dispatch(new ToggleComparisonAction({ isEnabled: comparison }))
  }, [comparison, dispatch])

  return (
    <label className={ cn(styles.toggleComparison, className, comparison && styles.enabled, !comparison && styles.disabled) }>
      Comparisons
      <div className={ styles.label }>
        <div className={ styles.on }>ON</div>
        <div className={ styles.off }>OFF</div>
      </div>
      <FutureCheckbox register={ register } name='comparison' className={ styles.checkbox } />
    </label>
  )
}
